import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';
import CommonPreviewFileModal from './components/CommonPreviewFileModal';

import CommonTokenExpired from './components/CommonTokenExpired';

import Cookies from "js-cookie";

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
import InputEB04DataCourse from './inputs/InputEB04DataCourse';
import SearchEB04DataCourse from './searchs/SearchEB04DataCourse';
import DataTableEB04DataCourse from './dataTables/DataTableEB04DataCourse';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/EB04DataCourseState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `course_eb_04`;
const URL = `api/master/${TABLE}`;

const rawProfile = Cookies.get("userProfile");
const userProfile = rawProfile ? JSON.parse(rawProfile) : {};

const allowedTypes = ["0", "1", "4"]; // 0 = admin, 1 = EEC staff, 2 = academy
const userPermit = allowedTypes.includes(userProfile.types);

const INSERT_NAME_IN_EB04 = `api/master/enroll-register`;

class EB04DataCourse extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
        // await this.setDefaultSearchs();
    }

    loadMasterbase = async () => {
        let sets = [
            {key: "academy", filter: [{field: "status", value: "0"}]},
            {key: "enterprise", filter: [{field: "status", value: "0"}]},
            {key: "external_user", filter: [{field: "status", value: "0"}]}
        ];

        Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search = false) => {
        const { Searchs, DataTable } = this.state;

        const cookieSearchs = {};
        if (userProfile.id && ["2"].includes(userProfile.types))  {
            cookieSearchs.external_id = { id: "academy_id", value: userProfile.academy_id };
        }else if (userProfile.id && !["3"].includes(userProfile.types))  {
            cookieSearchs.external_id = { id: "enterprise_id", value: userProfile.enterprise_id };
        }else if (userProfile.id && !["0","1","6"].includes(userProfile.types))  {
            cookieSearchs.external_id = { id: "external_id", value: userProfile.id };
        }

        const mergedSearchs = {
            ...Searchs,
            ...cookieSearchs,
            page: {
                id: "page",
                value: search ? 1 : DataTable.pagination.currentPage,
            },
        };

        await Actions.loadDataTable(
            this.updateState,
            `${URL}/pagination`,
            fn.getInputSearch(mergedSearchs)
        );
    }

    registerEnrollKey = async () => {   
        const { Action, Inputs, DataTable } = this.state;
        // let result = await Actions.getSomething(this.updateState, INSERT_NAME_IN_EB04 + id , {});
        let result = await Actions.submitData(
            this.updateState,
            INSERT_NAME_IN_EB04,
            Action.Mode,
            fn.getInputForm({...Inputs}),
        );
        if(!result.success){
            // this.updateSomething({target: {name: 'official_course_code', value: result.data}}, 'DataTable', {key: "id", value: id} );
            console.log("unsuccess isert to eb04");            
        }
    }

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true},
            this.state.Inputs
        );
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state;
    
        const payload = fn.getInputForm({ ...Inputs });
    
        await Actions.submitData(
            this.updateState,
            URL,
            Action.Mode,
            payload,
            this.loadDataTable
        );
    }
    
    setDefaultInputs = async () => {
        await Actions.setProfileInputs(this.updateState, {
            id: "external_id", // cookie.enterprise_id → Inputs.enterprise_id
        });
    }

    componentDidMount = async () => {
        await this.initialize(); 
    }

    componentDidUpdate = async () => {}    

    render = () => {

        let { Action, Searchs, DataTable, Inputs, InputGroup, Masterbase, Deletes, Operation, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonPreviewFileModal
                        Action={Action}
                        onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                    />

                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        userPermit={userPermit}
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true, this.setDefaultInputs)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchEB04DataCourse 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableEB04DataCourse 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        onDropDownChange={async(e, element, pk) => await this.updateSomething(e, element, pk) }

                        onPreviewFile={(e) => Actions.handlePreviewFile(this.updateState, e)}

                        onCheckDelete={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)}
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputEB04DataCourse 
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Inputs={Inputs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        
                        onPreviewFile={(e) => Actions.handlePreviewFile(this.updateState, e)}
                        onDeleteFile={(field, pk) => Actions.deleteFile(this.updateState, URL, field, pk)}

                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}
                        onSubmit={async (e) => { await this.submitData()}}                        
                        
                        onRegisterEnrollKey={async (e) => { await this.registerEnrollKey(); }  }

                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                            }
                        }
                    />

                </Container>
            </>
        )
    }
}

export default withRouter(EB04DataCourse);